import { render } from "./BoMenu.vue?vue&type=template&id=4508f96b"
import script from "./BoMenu.vue?vue&type=script&lang=js"
export * from "./BoMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__